// app/javascript/controllers/search_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.timeout = null;
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      fetch(`/lrk?query=${this.inputTarget.value}`, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
      })
        .then((response) => response.text())
        .then((html) => {
          document.getElementById("results").innerHTML = html;
        });
    }, 300);
  }

  clear(event) {
    event.preventDefault();
    event.stopPropagation();
    this.inputTarget.value = "";
    this.element.requestSubmit();
  }
}
